export default __webpack_public_path__ + "static/media/logo_ipnow.0cc3cbd4e3438fc9b4a0e4cdc1ac70be.svg";